/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Use_Arrow_Keys_Or_Click_To_NavigateInputs */

const en_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use arrow keys or click to navigate`)
};

const es_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa las flechas o haz clic para navegar`)
};

const fr_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez les flèches ou cliquez pour naviguer`)
};

const de_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwende die Pfeiltasten oder klicke zur Navigation`)
};

const ja_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`矢印キーを使用するか、クリックして移動します`)
};

const zh_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用方向键或点击进行导航`)
};

const ar_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدم مفاتيح الأسهم أو انقر للتنقل`)
};

const id_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gunakan tombol panah atau klik untuk menavigasi`)
};

const it_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa i tasti freccia o clicca per navigare`)
};

const ru_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте стрелки или клик для навигации`)
};

const pt_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as setas ou clique para navegar`)
};

const ko_use_arrow_keys_or_click_to_navigate = /** @type {(inputs: Use_Arrow_Keys_Or_Click_To_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`화살표 키를 사용하거나 클릭하여 탐색하세요`)
};

/**
* | output |
* | --- |
* | "Use arrow keys or click to navigate" |
*
* @param {Use_Arrow_Keys_Or_Click_To_NavigateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const use_arrow_keys_or_click_to_navigate = /** @type {((inputs?: Use_Arrow_Keys_Or_Click_To_NavigateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_Arrow_Keys_Or_Click_To_NavigateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "es") return es_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "fr") return fr_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "de") return de_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "ja") return ja_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "zh") return zh_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "ar") return ar_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "id") return id_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "it") return it_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "ru") return ru_use_arrow_keys_or_click_to_navigate(inputs)
	if (locale === "pt") return pt_use_arrow_keys_or_click_to_navigate(inputs)
	return ko_use_arrow_keys_or_click_to_navigate(inputs)
});